import AdvancedFeaturesSearchFilters from './AdvancedFeaturesSearchFilters'

export default AdvancedFeaturesSearchFilters
